import { spotById, type SpotId } from '../../utils/paths';

export interface WizardVariant {
  name: string;
  price: number;
  interval: 'week' | 'month' | 'year' | 'one_time';
  trialDays: number;
  initialFee?: number;
  hasInitialFee?: boolean;
  packageLabel?: string;
  promoCodeId?: string;
  promoCode?: string;
  promoAmountOff?: number;
  promoType?: 'percentage' | 'flat_amount';
  promoDuration?: 'forever' | 'once' | 'repeating';
  promoDurationMonths?: number | null;
}

export interface WizardData {
  companyId: string;
  productId: string;
  productName: string;
  basePlanId: string;
  // The plan buyers pay today, when a test can copy it exactly.
  baseOffer?: { price: number; interval: string; trialDays: number };
  name: string;
  currency: string;
  variants: WizardVariant[];
  split: { [key: string]: number };
}

/** Whether Control still is what buyers pay today, so it can be called that. */
export function controlIsToday(data: Pick<WizardData, 'baseOffer' | 'variants'>): boolean {
  const control = data.variants[0];
  const today = data.baseOffer;
  return Boolean(
    today &&
      control &&
      control.price === today.price &&
      control.interval === today.interval &&
      (control.trialDays ?? 0) === today.trialDays &&
      !control.promoCodeId
  );
}

/** A link spot chosen in "Place it", created as a `link` placement on go-live. */
export interface SpotDraft {
  key: string;
  spotId: SpotId;
  label: string;
  link?: string | null; // its real link, once the spot exists
}

/** One partner/campaign link, created as a `partner` placement. */
export interface PartnerDraft {
  key: string;
  label: string;
  affiliateCode: string;
}

export interface InWhopDraft {
  freeProductId: string;
  freeProductName: string;
}

let draftSeq = 0;
function nextKey(prefix: string): string {
  draftSeq += 1;
  return `${prefix}-${draftSeq}`;
}

export function newSpotDraft(spotId: SpotId): SpotDraft {
  return { key: nextKey('spot'), spotId, label: spotId === 'other' ? '' : spotById(spotId).label };
}

export function newPartnerDraft(): PartnerDraft {
  return { key: nextKey('partner'), label: '', affiliateCode: '' };
}
